import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { totalBasket, groupArrayByField, totalLineItem } from "../../../helpers";
import { DELIVERY } from "../../../constants";
import QuantitySelector from "../../../assets/QuantitySelector";
import { addProduct } from "../../../actions/basket";

export default function BasketSummary() {

	const dispatch = useDispatch();
	const { vendor, basket } = useSelector(state => ({
		vendor: state.vendor,
		basket: state.basket
	}));

	const [, , deliveryFee] = totalBasket(basket, vendor);

	const onBrand = {
		backgroundColor: vendor.featureColor1,
		color: vendor.featureColor2
	}

	const itemCount = basket.items.reduce((acc, item) => acc + item.quantity, 0);

	return <div className="summary">
		<div className="summary-heading flexy featureFont">
			<div className="speechbubble">
				<div className="bubble-inner" style={onBrand}>
					<span>
						All Done?
					</span>
				</div>
			</div>
			<div className="count">
				{itemCount} item{itemCount !== 1 && "s"}
				<br />
				in your basket
			</div>
		</div>
		<div className="summary-items">
			{basket.items.map(item => {

				const itemParent = item.product.parent ? vendor.products.find(product => product.id === item.product.parent) : null;
				const optionTypes = groupArrayByField(item.options
					.map(o => ({ ...o, addOn: vendor.addOns.find(addOn => addOn.id === o.addOn) }))
					.filter(o => o.addOn),
					"name");

				return <div className="line-item flexy" key={item.id}>
					<div className="name">
						{Boolean(itemParent) && <span>
							{itemParent.name + " - "}
						</span>}
						{item.product.name}
						{/* Iterate the option types */}
						{Object.entries(optionTypes).map(([name, options]) => (
							<div className="line-item-addOn-type" key={name}>
								<div><b>{name}:</b></div>
								{/* And then iterate each of the options */}
								{options.map(({ id: optionId, addOn, quantity }) => (
									<div className="line-item-addOn" key={optionId}>
										{addOn.name}{quantity !== 1 && ` x${quantity}`}
									</div>
								))}
							</div>
						))}
					</div>
					<div className="quantity text-right">
						<div className="price featureFont">
							£{(totalLineItem(item, vendor) / 100).toFixed(2)}
						</div>
						<QuantitySelector
							value={item.quantity}
							onChange={newQuantity => {
								dispatch(addProduct(item.product, newQuantity - item.quantity, item.options));
							}}
						/>
					</div>
				</div>
			})}
			{/* The delivery price. */}
			{basket.type === DELIVERY && <div className="line-item flexy">
				<div className="name">
					Delivery
				</div>
				{deliveryFee ?
					<div className="price featureFont text-right">
						£{(deliveryFee / 100).toFixed(2)}
					</div>
					:
					<div className="price featureFont text-right">
						FREE
					</div>
				}
			</div>}
			{/* And finally the Orderabl fee. */}
			<div className="line-item flexy">
				<div className="name">
					Service fee
				</div>
				<div className="price featureFont text-right">
					£0.50
				</div>
			</div>
		</div>
	</div>
}